// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Theme colors – configurable via .env
const primary = process.env.VUE_APP_COLOR_PRIMARY || '#28190E'
const secondary = process.env.VUE_APP_COLOR_SECONDARY || '#7D8570'
const accent = process.env.VUE_APP_COLOR_ACCENT || '#92B513'
const background = process.env.VUE_APP_COLOR_BACKGROUND || '#F5F2ED'
const surface = process.env.VUE_APP_COLOR_SURFACE || '#FFFFFF'
const error = process.env.VUE_APP_COLOR_ERROR || '#D95D39'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary,
          secondary,
          accent,
          error,
          background,
          surface,
        }
      },
    },
  },
})
